<template>
  <div
    data-grid="nowrap"
    class="content-tabs align-items-center w-100"
  >
    <ul
      data-grid="nowrap"
      class="content-tabs-list h-100 align-items-center"
    >
      <template
        v-for="({ label, destiny: routerName }, index) in tabList"
        :key="routerName"
      >
        <Skeleton
          v-if="loading"
          class="h-100"
          :class="{ 'ms-10': index }"
        />

        <Tab
          v-else
          :class="{ 'ms-10': index }"
          v-bind="{ label, routerName }"
        />
      </template>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import Tab from './components/tab'
import Skeleton from '../../global/Skeleton'

export default defineComponent({
  name: 'ContentTabs',

  components: {
    Tab,
    Skeleton
  },

  props: {
    loading: Boolean,

    tabList: {
      type: Array,
      required: true,
      validator (tabs) {
        tabs.forEach(({ label, destiny }) => {
          if (!(label || destiny)) throw new Error('tabs must have both "label" and "destiny" keys.')
        })

        return true
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .content-tabs {
    z-index: 2;
    height: 60px;
    flex: 0 0 60px;
    margin: 43px 0;

    .skeleton {
      width: 115px;
    }
  }
</style>
